import Vue from "vue"
import Vuex from "vuex"
import createPlugin from "logrocket-vuex"
import LogRocket from "logrocket"

import auth from "./modules/auth"
import bindings from "./modules/bindings"
import categories from "./modules/categories"
import users from "./modules/users"
import error from "./modules/error"
import layout from "./modules/layout"
import products from "./modules/products"
import orders from "./modules/orders"
import organizations from "./modules/organizations"
import imprints from "./modules/imprints"
import imprintDiscounts from "./modules/imprintDiscounts"
import notifications from "./modules/notifications"
import selects from "./modules/selects"
import flags from "./modules/flags"
import promotions from "./modules/promotions"
import giftcards from "./modules/giftcards"
import verificationRequests from "./modules/verification-requests"
import tenants from './modules/tenants'
import examCopyRequests from './modules/exam-copy-requests'
import authors from './modules/authors'

Vue.use(Vuex)

const plugins = []
if (process.env.VUE_APP_LOGROCKET_KEY) {
  const logrocketPlugin = createPlugin(LogRocket)
  plugins.push(logrocketPlugin)
}

// Create a new store
const store = new Vuex.Store({
  modules: {
    auth,
    bindings,
    categories,
    users,
    error,
    layout,
    products,
    imprints,
    imprintDiscounts,
    orders,
    organizations,
    tenants,
    authors,
    notifications,
    selects,
    flags,
    promotions,
    giftcards,
    verificationRequests,
    examCopyRequests
  },
  plugins
})

export default store
